import { THEME_CHOICE } from "@/store/themeCustom";
import HomeThemeDefault from "@/assets/theme_1/home.svg";
import InvoiceDetailThemeDefault from "@/assets/theme_1/invoice_detail.svg";
import AddCardThemeDefault from "@/assets/theme_1/add_card.svg";

import HomeThemeAmethyst from "@/assets/theme_2/home.svg";
import InvoiceDetailThemeAmethyst from "@/assets/theme_2/invoice_detail.svg";
import AddCardThemeAmethyst from "@/assets/theme_2/add_card.svg";
import { SwiperCard } from "@/components/swiper";

export const THEMES_SWIPER: Record<THEME_CHOICE, SwiperCard[]> = {
  [THEME_CHOICE.THEME_DEFAULT]: [
    {
      image: HomeThemeDefault,
      title: "home",
    },
    {
      image: InvoiceDetailThemeDefault,
      title: "Invoice detail",
    },
    {
      image: AddCardThemeDefault,
      title: "Add card",
    },
  ],
  [THEME_CHOICE.THEME_AMETHYST]: [
    {
      image: HomeThemeAmethyst,
      title: "home",
    },
    {
      image: InvoiceDetailThemeAmethyst,
      title: "Invoice detail",
    },
    {
      image: AddCardThemeAmethyst,
      title: "Add card",
    },
  ],
};
